import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">影片索引</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按分类快速浏览海量影视资源，总有一部适合你
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <div
              key={item.id}
              className="group rounded-xl bg-background-100 border border-background-200/60 p-5 text-center hover:border-primary-500/40 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-full bg-primary-500/10 flex items-center justify-center mx-auto mb-3 group-hover:bg-primary-500/20 transition-colors duration-200">
                <i className={`${item.icon} text-primary-500 text-xl w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">{item.title}</h3>
              <span className="text-xs text-foreground-500 whitespace-nowrap">{item.count.toLocaleString()} 部影片</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}